"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

var _react = _interopRequireDefault(require("react"));

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

var FlagKN = function FlagKN(props) {
  return /*#__PURE__*/_react["default"].createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: "411.6",
    height: "270.36",
    viewBox: "0 0 411.6 270.36"
  }, props), /*#__PURE__*/_react["default"].createElement("path", {
    d: "M209.54,146.36H-185.94A7.06,7.06,0,0,1-193,139.3V-114.94a7.06,7.06,0,0,1,7.06-7.06H209.54a7.06,7.06,0,0,1,7.06,7.06V139.3a7.06,7.06,0,0,1-7.06,7.06Zm0,0",
    transform: "translate(194 123)",
    fill: "#73af00"
  }), /*#__PURE__*/_react["default"].createElement("path", {
    d: "M107.07-122-193,74.6V95.7L139.28-122Zm0,0",
    transform: "translate(194 123)",
    fill: "#ffe15a"
  }), /*#__PURE__*/_react["default"].createElement("path", {
    d: "M216.6-50.24v-21.1l-332.28,217.7h32.21Zm0,0",
    transform: "translate(194 123)",
    fill: "#ffe15a"
  }), /*#__PURE__*/_react["default"].createElement("path", {
    d: "M216.6-71.34v-43.6a7.06,7.06,0,0,0-7.06-7.06H139.28L-193,95.7v43.6a7.06,7.06,0,0,0,7.06,7.06h70.26Zm0,0",
    transform: "translate(194 123)",
    fill: "#464655"
  }), /*#__PURE__*/_react["default"].createElement("path", {
    d: "M-68.19,28.1l14.5,11.67,15.74-9.93a2.51,2.51,0,0,1,3.68,3L-40.9,50.24l14.32,11.9a2.51,2.51,0,0,1-1.73,4.43l-18.59-.93-6.89,17.29a2.51,2.51,0,0,1-4.75-.27l-4.86-18L-82,63.49a2.51,2.51,0,0,1-1.21-4.6L-67.6,48.71l-4.59-18a2.51,2.51,0,0,1,4-2.57Zm0,0",
    transform: "translate(194 123)",
    fill: "#f5f5f5"
  }), /*#__PURE__*/_react["default"].createElement("path", {
    d: "M65.41-59.59,79.9-47.92l15.74-9.93a2.5,2.5,0,0,1,3.68,3L92.7-37.45,107-25.55a2.51,2.51,0,0,1-1.73,4.43L86.7-22,79.8-4.75A2.51,2.51,0,0,1,75.05-5L70.19-23,51.62-24.2a2.51,2.51,0,0,1-1.21-4.6L66-39,61.4-57a2.51,2.51,0,0,1,4-2.57Zm0,0",
    transform: "translate(194 123)",
    fill: "#f5f5f5"
  }), /*#__PURE__*/_react["default"].createElement("path", {
    d: "M216.6,139.3V-50.24L-83.47,146.36h293a7.06,7.06,0,0,0,7.06-7.06Zm0,0",
    transform: "translate(194 123)",
    fill: "#ff4b55"
  }), /*#__PURE__*/_react["default"].createElement("rect", {
    x: "1",
    y: "1",
    width: "409.6",
    height: "268.36",
    rx: "7",
    ry: "7",
    fill: "none"
  }));
};

var _default = FlagKN;
exports["default"] = _default;